import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import _ from 'lodash';

import { TestService } from '../../services/test.service';

const EDITED_PROPERTIES = 'editedProperties';
const KEEP_ORIGINAL_DATA = 'keepOriginalData';

@Component({
  selector: 'gen-collection-form',
  templateUrl: './collection-form.component.html',
  styleUrls: ['./collection-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionFormComponent implements OnInit {

  @Input() resourceProperty: string = '';
  @Input() relevantFormsList: string[] = [];
  @Input() formData: any = null;

  @Output() formDataUpdatedEvent: EventEmitter<any> = new EventEmitter<any>();

  public formsConfig: any[] = [];

  private defaultFieldValues: any = [];
  private keepOriginalData: boolean = false;
  private editedProperties: any = {};

  constructor(
    private testService : TestService
  ) {
  }

  ngOnInit() {
    const testConfiguration = this.testService.testConfiguration;

    if (testConfiguration) {
      const additionalFormsConfig = Array.isArray(testConfiguration.additionalDataFormsConfig) ? testConfiguration.additionalDataFormsConfig : [];

      // show only relevant forms!
      if (this.relevantFormsList && this.relevantFormsList.length > 0) {
        additionalFormsConfig.forEach((item: any) => {
          if (_.includes(this.relevantFormsList, item.key)) {
            this.formsConfig.push(item);
          }
        });
      }

      _.forEach(this.formsConfig, config => {
        if (config.hasOwnProperty(KEEP_ORIGINAL_DATA) && config[KEEP_ORIGINAL_DATA] == true) {
          this.keepOriginalData = true;
          this.defaultFieldValues[config.key] = _.cloneDeep(this.formData);

          // if there are edited properties
          if (_.has(this.formData, EDITED_PROPERTIES)) {
            // copy from edited properties to form data
            _.merge(this.formData, this.formData[EDITED_PROPERTIES]);
            this.editedProperties = this.formData[EDITED_PROPERTIES];
          }
        }
      });
    }
  }

  ngOnDestroy() {
    this.defaultFieldValues = undefined;
  }

  trackByFormId(formConfig: any): string {
    return formConfig.formId;
  }

  updateRelevantResource(updatedProperties: string[], subForm: any, formKey: string = null): void {
    const changedFields: Object = {};

    updatedProperties.forEach((property: string) => {
      const newValue = _.get(subForm, property);
      _.set(changedFields, property, newValue);
    });

    if (!_.isEmpty(changedFields)) {
      if (this.keepOriginalData) {
        // restore initial data
        this.formData = _.cloneDeep(this.defaultFieldValues[formKey]);

        _.forOwn(changedFields, (value, key) => {
          _.set(this.editedProperties, key, value);
        });

        this.formData[EDITED_PROPERTIES] = this.editedProperties;
      } else {
        _.forOwn(changedFields, (value, key) => {
          _.set(this.formData, key, value);
        });
      }
    }

    this.formDataUpdatedEvent.emit({
      formData: this.formData,
      changedFields: changedFields,
      keepOriginalData: this.keepOriginalData,
      resourceProperty: this.resourceProperty
    });
  }
}
